import { z } from 'zod';
/**
 * Gift codes (ADR 0063): a word typed in the shop hands the items it holds
 * to the character playing, once per account. Over HTTP like the shop: the
 * code is the account's business, not the zone's.
 */
/** Letters, digits and dashes; the server compares codes in upper case. */
export const GIFT_CODE_PATTERN = /^[A-Z0-9-]{3,32}$/;
/** What the player typed, as the server compares it: trimmed, upper case, inner spaces gone. */
export function normaliseGiftCode(raw) {
    return raw.trim().toUpperCase().replaceAll(/\s+/g, '');
}
/** `POST /shop/redeem`: the character session says who, the body which code. */
export const GiftCodeRedeemRequestSchema = z.object({ code: z.string().min(1).max(64) }).strict();
export const GiftCodeItemSchema = z.object({
    templateId: z.string().min(1).max(64),
    quantity: z.number().int().min(1).max(999),
});
/** What the code put in the bag. */
export const GiftCodeRedeemResponseSchema = z.object({ items: z.array(GiftCodeItemSchema) });
export const GIFT_CODE_REFUSALS = [
    /** No such code, or not a code at all. */
    'unknown-code',
    /** Past its end date. */
    'expired-code',
    /** Every use it was made with is spent. */
    'exhausted-code',
    /** This account already used it, or another code of its campaign, on any of its characters. */
    'already-redeemed',
    'bag-full',
];
//# sourceMappingURL=gift-codes.js.map